import { createResourceCollection } from '@/request'
import { EnergySystem } from '@/types/energySystem'

export const energySystemCollection = createResourceCollection<EnergySystem>({
  name: 'energySystemCollection',
  selector: (state) => state.energySystemCollection,
})

export default energySystemCollection.slice.reducer
